import { highDemandBtnAdapter } from './adapters';
import { partnerState } from './store';
import { SATURATION } from '../domain';

import type { HighDemandBtnHandler } from '../domain';

export const highDemandBtnHandler = {
  get,
} as const;

function get(): ReturnType<HighDemandBtnHandler['get']> {
  const { saturation, stores, isFastOperation, isFastFromOCC } = partnerState();
  return {
    storesListByStatus: highDemandBtnAdapter.toStoresStatusList(stores),
    saturation: (() => {
      if (isFastFromOCC) return SATURATION.fastFromOCC;
      else if (isFastOperation) return SATURATION.fast;
      return highDemandBtnAdapter.toModelSaturation(saturation);
    })(),
  };
}
